import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { ErrorListService } from '../../services/error-list.service';
import { Subscription } from 'rxjs';

export interface ErrorType {
  head: string;
  field: string;
  isRepeated?: boolean;
};

@Component({
  selector: 'app-error-list',
  imports: [],
  templateUrl: './error-list.component.html',
  styleUrl: './error-list.component.scss',
})
export class ErrorListComponent implements OnInit,OnDestroy {
  headTitle: string = 'Detected Errors';
  errorList: any[] = [];
  errorTableHead: ErrorType[] = [];
  showPopUp: boolean = false;

  private errorListSubscription: Subscription = new Subscription();
  private readonly errorListService: ErrorListService = inject(ErrorListService);

  ngOnInit() {
    this.errorListSubscription = this.errorListService.getErrorData().subscribe((data) => {
      const { errorList, errorTableHead } = this.errorListService.processErrorList(data);
      this.errorList = errorList;
      this.errorTableHead = errorTableHead;
      if(errorTableHead.length === 1 && errorTableHead[0].field === this.errorListService.field3){
        this.headTitle = 'Detected Warnings';
      }
      if(errorList.length > 0){
        this.onOpenPopUp();
      }
    });
  }

  onClosePopUp() {
    this.showPopUp = false;
  }

  onOpenPopUp() {
    this.showPopUp = true;
  }

  ngOnDestroy() {
    this.errorListSubscription.unsubscribe();
  }
}
